 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"4d24f988b8fc6cfd647c11e12ec7b10a1bb19a0f","2":"fb4f1dc4bf9e52ec397b042c543962074b1d1fe1","3":"6e7812e7e3dcefad0fc59f199de1ffe92897c471","4":"framework","5":"4cb0de93badf42b4365f218e7593d139d43a18a9","6":"6d12c8fb9aede054da21a5deb9b1afd8da3e90f5","7":"1cb77ea1fec76f21bc8f124c93bf6f616ada8bf0","8":"450b66071139dd3761e2e5f4358dff41ab687aa3","9":"808a4695ecadcef7203387a80d35629ac805e4ba","10":"a879f48c100ff43dcde1847c2ed41767d4736d65","11":"5f8f37c766cb3e870adb2c5c285f9fe1ffaf347c","12":"9a77a32f09e205ac202505312453336fc2c9f5fb","13":"9f3bf97324e6529d5f92205ad461433e2e33bb2b","14":"df5c613250ae2445484c4db4764d206204808a6f","15":"e0964c8fc51d0049a2b7cf74729e64d21815a450","18":"component---src-pages-404-js","19":"component---src-pages-about-us-js","20":"component---src-pages-aff-2022-js","21":"component---src-pages-contact-us-js","22":"component---src-pages-demo-cgi-js","23":"component---src-pages-demo-js","24":"component---src-pages-index-js","25":"component---src-pages-ironcap-bountycontest-ct-js","26":"component---src-pages-ironcap-bountycontest-en-js","27":"component---src-pages-ironcap-bountycontest-js","28":"component---src-pages-ironcap-bountycontest-wechat-callback-js","29":"component---src-pages-ironcap-toolkits-about-js","30":"component---src-pages-ironcap-toolkits-faq-js","31":"component---src-pages-ironcap-toolkits-index-js","32":"component---src-pages-ironcap-toolkits-support-js","33":"component---src-pages-ironcap-toolkits-videos-js","34":"component---src-pages-ironcap-toolkits-white-papers-use-cases-js","35":"component---src-pages-ironcap-x-about-js","36":"component---src-pages-ironcap-x-business-js","37":"component---src-pages-ironcap-x-faq-js","38":"component---src-pages-ironcap-x-index-js","39":"component---src-pages-ironcap-x-personal-js","40":"component---src-pages-ironcap-x-support-js","41":"component---src-pages-ironcap-x-versions-latest-en-index-js","42":"component---src-pages-ironcap-x-versions-v-1-0-en-index-js","43":"component---src-pages-ironcap-x-versions-v-1-1-en-index-js","44":"component---src-pages-ironcap-x-versions-v-1-2-en-index-js","45":"component---src-pages-ironcap-x-versions-v-2-0-en-index-js","46":"component---src-pages-ironcap-x-videos-js","47":"component---src-pages-ironcap-x-welcome-js","48":"component---src-pages-ironcap-x-white-papers-use-cases-js","49":"component---src-pages-news-js","50":"component---src-pages-page-not-found-js","51":"component---src-pages-partners-js","52":"component---src-pages-support-js","53":"component---src-pages-videos-js","54":"component---src-pages-white-papers-use-cases-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"c9d4418cd3074296890f","2":"fa160d8a8693d1f29e08","3":"1b6332bf080cf8f111ac","4":"79140972aa25952e3ccf","5":"9df87eb2e247ff215d5a","6":"e380719ab7610358b413","7":"f9d62a7980f7a2b7e655","8":"2c247632749bf517b320","9":"a855afb976a8ab10656c","10":"33b7b56772ab9da8c1ba","11":"fffae1f4c1c083eb5767","12":"0c33244a5be917ed16fe","13":"f5140c05f9d488bd6d47","14":"c3187b6360b7ea6d6ea6","15":"94be9b0d3485980f7e03","18":"e912e6f3fd28b89dbc11","19":"fd25d4d3e014ec9808c0","20":"4f81c6e3176f3f2e880c","21":"0b845ce2e589f9becc45","22":"c007d29198409b027f43","23":"a112ec6069b05c7af333","24":"7c96339f9a745710c84d","25":"f95af77f25325c664a8e","26":"073e3b392ec2b543a159","27":"08c65c3562038b1f89d8","28":"0a2634471d642d832339","29":"01c2a83b94cd1ddbfa0d","30":"a97b3aa7cde82bd2ca29","31":"fd47d1e3a5e5cb372ea6","32":"298228e9ac3340c4eb04","33":"cd9a061ed268b969cda0","34":"3e35a012b2236fde3bee","35":"57c2d7cd0e637afe3b9f","36":"ccdb51b9dc0a64272308","37":"e1cb5027ed79bb59a19e","38":"bd0e623b1bfd24c7be00","39":"d6d5681eaed21d7e57f8","40":"22290d845d5372689042","41":"024f5a76abf2ebf09731","42":"1da485c58ad40c777313","43":"e8453a57a6877cf802f9","44":"d003470001ff6b705a5d","45":"7988f03fec478930c600","46":"aa283fd353ad74a38ef0","47":"f233f74c8fe3f12f2693","48":"a9522661f439abf51636","49":"5a244977a46daa2e9c71","50":"a82d1257b34e00ec15d6","51":"897a22c507cb5ed15074","52":"13394e7b5a8cf27e6a71","53":"0151b95556056392d699","54":"a346744a278c35b4abf0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"4d24f988b8fc6cfd647c11e12ec7b10a1bb19a0f","2":"fb4f1dc4bf9e52ec397b042c543962074b1d1fe1","3":"6e7812e7e3dcefad0fc59f199de1ffe92897c471","4":"framework","5":"4cb0de93badf42b4365f218e7593d139d43a18a9","6":"6d12c8fb9aede054da21a5deb9b1afd8da3e90f5","7":"1cb77ea1fec76f21bc8f124c93bf6f616ada8bf0","8":"450b66071139dd3761e2e5f4358dff41ab687aa3","9":"808a4695ecadcef7203387a80d35629ac805e4ba","10":"a879f48c100ff43dcde1847c2ed41767d4736d65","11":"5f8f37c766cb3e870adb2c5c285f9fe1ffaf347c","12":"9a77a32f09e205ac202505312453336fc2c9f5fb","13":"9f3bf97324e6529d5f92205ad461433e2e33bb2b","14":"df5c613250ae2445484c4db4764d206204808a6f","15":"e0964c8fc51d0049a2b7cf74729e64d21815a450","18":"component---src-pages-404-js","19":"component---src-pages-about-us-js","20":"component---src-pages-aff-2022-js","21":"component---src-pages-contact-us-js","22":"component---src-pages-demo-cgi-js","23":"component---src-pages-demo-js","24":"component---src-pages-index-js","25":"component---src-pages-ironcap-bountycontest-ct-js","26":"component---src-pages-ironcap-bountycontest-en-js","27":"component---src-pages-ironcap-bountycontest-js","28":"component---src-pages-ironcap-bountycontest-wechat-callback-js","29":"component---src-pages-ironcap-toolkits-about-js","30":"component---src-pages-ironcap-toolkits-faq-js","31":"component---src-pages-ironcap-toolkits-index-js","32":"component---src-pages-ironcap-toolkits-support-js","33":"component---src-pages-ironcap-toolkits-videos-js","34":"component---src-pages-ironcap-toolkits-white-papers-use-cases-js","35":"component---src-pages-ironcap-x-about-js","36":"component---src-pages-ironcap-x-business-js","37":"component---src-pages-ironcap-x-faq-js","38":"component---src-pages-ironcap-x-index-js","39":"component---src-pages-ironcap-x-personal-js","40":"component---src-pages-ironcap-x-support-js","41":"component---src-pages-ironcap-x-versions-latest-en-index-js","42":"component---src-pages-ironcap-x-versions-v-1-0-en-index-js","43":"component---src-pages-ironcap-x-versions-v-1-1-en-index-js","44":"component---src-pages-ironcap-x-versions-v-1-2-en-index-js","45":"component---src-pages-ironcap-x-versions-v-2-0-en-index-js","46":"component---src-pages-ironcap-x-videos-js","47":"component---src-pages-ironcap-x-welcome-js","48":"component---src-pages-ironcap-x-white-papers-use-cases-js","49":"component---src-pages-news-js","50":"component---src-pages-page-not-found-js","51":"component---src-pages-partners-js","52":"component---src-pages-support-js","53":"component---src-pages-videos-js","54":"component---src-pages-white-papers-use-cases-js"}[chunkId]||chunkId) + "." + {"0":"f00afc987d7f75a1eb25","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
